import { fireLinkTag } from './tagManager';

export function tagShopTheSetMemberClick() {
  fireLinkTag({
    event_name: 'pdp shop the set product click',
    link_name: 'pdp shop the set product click',
  });
}
